require('webpack-jquery-ui/selectmenu');
require('webpack-jquery-ui/datepicker');
require("../app/form.coffee")
require("../app/gratitude_block.coffee")
require("../app/feedback_admin.coffee")

window.pageInitFlag = false

pageInit = ->
  # formreset();
  new window.Form()
  new window.Gratitude()

  $('.base-radio-label').click ->
    if ($('.virtual-reception__method_email, #form_checkbox_SIMPLE_QUESTION_433_1').prop('checked'))
      $('.js-change-radio-text').css('display', 'inline');
    else
      $('.js-change-radio-text').css('display', 'none');



$(document).ready ->
  if window.pageInitFlag == false
    pageInit()
  window.pageInitFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/virtual_reception.coffee